import {
    deleteFileMonth,
    deleteTaxDocument,
    getAllFilesUploadedByYear,
    getSpreadsheetByMonth,
    getUrlsFilesHistory,
    uploadFileExcel,
} from "@/api/uploadFiles";

export default {
    // state como factory: forward-compatible con Vuex 4 / Pinia (cada instancia
    // del store obtiene su propio objeto, no una referencia compartida).
    state: () => ({
        typeFiles: [
            {
                label: "🧑‍💻 Libro de Remuneraciones",
                counterpartType: "Trabajador",
                value: "remuneracion-clf",
                subTittle:
                    "Visualiza a todos los trabajadores y sus remuneraciones asociadas al mes.",
                alertTittle: "Elige cómo cargar las remuneraciones",
                alertSubTittle:
                    "Descarga una plantilla vacía o usa los datos del mes anterior.",
                TEMPLATE: "1p1h74zrCmQx8eK2q415teaZ4LITAUXXDaCcgr-ahN3w",
                nameTemplate: "Plantilla de remuneraciones.xlsx",
                searcherPlaceHolder: "Buscar por rut o nombre del trabajador",
                headers: [
                    {
                        label: "Mes Trabajado",
                        width: "15",
                        orderKey: "emitted_at",
                        formatDate: "MMM-YYYY",
                    },
                    {
                        label: "Rut del Trabajador",
                        width: "10",
                        orderKey: "rut",
                        nestedPath: "companies_involved.counterpart.rut",
                    },
                    {
                        label: "Nombre del trabajador",
                        width: "15",
                        orderKey: "name_counterpart",
                        nestedPath: "companies_involved.alias",
                    },
                    {
                        label: "Costo Empresa",
                        width: "15",
                        orderKey: "amount",
                        nestedPath: "amount",
                    },
                    {
                        label: "Cuenta Madre",
                        width: "11",
                        orderKey: "mother_account",
                    },
                    {
                        label: "Cuenta",
                        width: "12",
                        orderKey: "account",
                    },
                ],
            },
            {
                label: "🌍 Facturas Extranjeras / Invoices",
                counterpartType: "Internacional",
                value: "invoices-clf",
                subTittle: "Sube aquí tus facturas emitidas en el extranjero.",
                alertTittle: "Elige cómo cargar las facturas extranjeras",
                alertSubTittle: `Descarga una plantilla o reutiliza datos del mes anterior.
                    Asegúrate de convertir todos los montos a PESOS CHILENOS (CLP) antes de subirlos.`,
                TEMPLATE: "108QdL9H4xolu5dldho7SbeuH_OWi_4SMQN_hECVz8cc",
                nameTemplate: "Plantilla de facturas extranjeras.xlsx",
                searcherPlaceHolder: "Buscador",
                headers: [
                    {
                        label: "Fecha de Emisión",
                        width: "15",
                        orderKey: "emitted_at",
                        formatDate: "DD-MM-YYYY",
                    },
                    {
                        label: "Nombre del Proveedor",
                        width: "25",
                        orderKey: "name_counterpart",
                        nestedPath: "companies_involved.alias",
                    },
                    {
                        label: "Monto (CLP)",
                        width: "15",
                        orderKey: "amount",
                        nestedPath: "amount",
                    },
                    {
                        label: "Cuenta Madre",
                        width: "11",
                        orderKey: "mother_account",
                    },
                    {
                        label: "Cuenta",
                        width: "12",
                        orderKey: "account",
                    },
                ],
            },
            {
                label: "🧾 Recibos",
                counterpartType: "Recibo",
                value: "recibos-clf",
                subTittle:
                    "Sube aquí tus recibos que no poseen respaldo del Sii.",
                alertTittle: "Elige cómo cargar los recibos",
                alertSubTittle: `Descarga una plantilla o reutiliza datos del mes anterior.`,
                TEMPLATE: "1Q2ovE1uqkdT2fNhD2p3uL1P6Ysnhr_44pYuCaRsMeOw",
                nameTemplate: "Plantilla de recibos.xlsx",
                searcherPlaceHolder: "Buscador",
                headers: [
                    {
                        label: "Fecha de Emisión",
                        width: "15",
                        orderKey: "emitted_at",
                        formatDate: "DD-MM-YYYY",
                    },
                    {
                        label: "Nombre Proveedor / Item",
                        width: "15",
                        orderKey: "name_counterpart",
                        nestedPath: "companies_involved.alias",
                    },
                    {
                        label: "Detalle Gasto",
                        width: "10",
                        orderKey: "description",
                        nestedPath: "description",
                    },
                    {
                        label: "Monto (CLP)",
                        width: "15",
                        orderKey: "amount",
                        nestedPath: "amount",
                    },
                    {
                        label: "Cuenta Madre",
                        width: "11",
                        orderKey: "mother_account",
                    },
                    {
                        label: "Cuenta",
                        width: "12",
                        orderKey: "account",
                    },
                ],
            },
            {
                label: "💵 Notas de Venta",
                counterpartType: "Nota de Venta",
                value: "notas-venta-clf",
                subTittle:
                    "Sube aquí tus notas de venta que no poseen respaldo del Sii.",
                alertTittle: "Elige cómo cargar las notas de venta",
                alertSubTittle: `Descarga una plantilla o reutiliza datos del mes anterior.`,
                // Plantilla propia de notas de venta (2026-08-05, ver
                // docs/DECISIONES.md §9): Google Sheet nativa en Drive
                // (Files.Export del servicio Go solo funciona con archivos
                // nativos). El backend valida los títulos de columna contra
                // HEADER_SALE_NOTES.
                TEMPLATE: "1OE9NgzoT8ft2Eac6l4BpF_QACsM16Qd5uktfc2FdAHY",
                nameTemplate: "Plantilla de notas de venta.xlsx",
                searcherPlaceHolder: "Buscador",
                headers: [
                    {
                        label: "Fecha de Emisión",
                        width: "15",
                        orderKey: "emitted_at",
                        formatDate: "DD-MM-YYYY",
                    },
                    {
                        label: "Nombre Cliente / Item",
                        width: "15",
                        orderKey: "name_counterpart",
                        nestedPath: "companies_involved.alias",
                    },
                    {
                        label: "Detalle Venta",
                        width: "10",
                        orderKey: "description",
                        nestedPath: "description",
                    },
                    {
                        label: "Monto (CLP)",
                        width: "15",
                        orderKey: "amount",
                        nestedPath: "amount",
                    },
                    {
                        label: "Cuenta Madre",
                        width: "11",
                        orderKey: "mother_account",
                    },
                    {
                        label: "Cuenta",
                        width: "12",
                        orderKey: "account",
                    },
                ],
            },
            {
                label: "📄 Finiquitos",
                counterpartType: "Finiquito",
                value: "finiquitos-clf",
                subTittle: "Sube aquí los finiquitos emitidos este mes.",
                alertTittle: "Elige cómo cargar los finiquitos",
                alertSubTittle: `Descarga una plantilla`,
                TEMPLATE: "1drlzF7vuxYWkXhYqM8HRt_I_-WtWSX8Tob7iB0jrb64",
                nameTemplate: "Plantilla de finiquitos.xlsx",
                searcherPlaceHolder: "Buscador",
                headers: [
                    {
                        label: "Fecha del Finiquito",
                        width: "15",
                        orderKey: "emitted_at",
                        formatDate: "DD-MM-YYYY",
                    },
                    {
                        label: "Rut del Trabajador",
                        width: "10",
                        orderKey: "rut",
                        nestedPath: "companies_involved.counterpart.rut",
                    },
                    {
                        label: "Nombre del Trabajador",
                        width: "15",
                        orderKey: "name_counterpart",
                        nestedPath: "companies_involved.alias",
                    },
                    {
                        label: "Monto (CLP)",
                        width: "15",
                        orderKey: "amount",
                        nestedPath: "amount",
                    },
                    {
                        label: "Cuenta Madre",
                        width: "11",
                        orderKey: "mother_account",
                    },
                    {
                        label: "Cuenta",
                        width: "12",
                        orderKey: "account",
                    },
                ],
            },
        ],
        selectedTypeFile: {},
        selectedDate: {
            year: 0,
            month: "",
        },
    }),

    mutations: {
        SET_SELECTED_DATE: (state, payload) => {
            state.selectedDate = payload;
        },
        SET_SELECTED_TYPE_FILE: (state, payload) => {
            state.selectedTypeFile = payload;
        },
    },
    actions: {
        setNewSelectedDate({ commit }, payload) {
            commit("SET_SELECTED_DATE", payload);
        },
        setNewSelectedTypeFile({ commit, state }, payload) {
            const selectedTypeFile = state.typeFiles.find(
                (typeFile) => typeFile.value == payload,
            );
            commit("SET_SELECTED_TYPE_FILE", selectedTypeFile);
        },
        // Wrappers finos sobre api/uploadFiles: la orquestación HTTP del flujo de
        // subida vive en la capa Vuex, no en el componente. Devuelven `data`.
        async fetchSpreadsheetByMonth(_ctx, payload) {
            const { data } = await getSpreadsheetByMonth(payload);
            return data;
        },
        async fetchFilesUploadedByYear(_ctx, payload) {
            const { data } = await getAllFilesUploadedByYear(payload);
            return data;
        },
        // Historial de archivos subidos (modal Historico de DashboardFileUpload).
        async fetchUrlsFilesHistory() {
            const { data } = await getUrlsFilesHistory();
            return data;
        },
        async uploadSpreadsheetExcel(_ctx, formData) {
            const { data } = await uploadFileExcel(formData);
            return data;
        },
        deleteSpreadsheetMonth(_ctx, id) {
            return deleteFileMonth(id);
        },
        removeTaxDocument(_ctx, payload) {
            return deleteTaxDocument(payload);
        },
    },
    namespaced: true,
};
